module.exports = __webpack_public_path__ + "img/confirm2_th.33758ec0.png";